import { Order } from 'shared/types/cart';
import Link from 'components/gruenland/atoms/link';
import Typography from 'components/gruenland/atoms/typography';
import OrderCosts from 'components/gruenland/organisms/order-costs/OrderCosts';
import OrderItemsList from 'components/gruenland/organisms/order-items-listing/OrderItemsList';
import { useFormat } from 'helpers/hooks/useFormat';
import { TYPOGRAPHY_PRIVATE_AREA_TITLE } from 'lib/typography';
import { ShippingMethod } from 'types/entity/cart';
import OrderDetails from './OrderDetails';
import OrderShippingDetails from './OrderShippingDetails';
import useOrderData from '../helper-hooks/useOrderData';

export interface Props {
  order: Order;
  shippingMethods: ShippingMethod[];
}

const OrderPage: React.FC<Props> = ({ order, shippingMethods }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const { shippingInfo } = useOrderData({
    order,
    shippingMethods,
  });

  return (
    order && (
      <>
        <Typography as="h2" className={TYPOGRAPHY_PRIVATE_AREA_TITLE}>
          {formatMessage({
            id: 'order.details',
            defaultMessage: 'Order Details',
          })}
        </Typography>
        <div className="mt-6 flex flex-col gap-4 xl:flex-row xl:gap-20">
          <div className="xl:w-1/2">
            <OrderDetails order={order} />
            <OrderShippingDetails order={order} shippingInfo={shippingInfo} />
          </div>
          <div className="xl:w-1/2">
            <OrderCosts order={order} className="bg-neutrals-gray-light p-2" />

            {order.invoiceUrl && (
              <Link link={order.invoiceUrl} target="_blank" variant="buttonPrimaryGreen" className="mt-2">
                <Typography className="text-center text-[14px] md:text-[16px]">
                  {formatMessage({
                    id: 'order.invoice',
                    defaultMessage: 'Fattura',
                  })}
                </Typography>
              </Link>
            )}
          </div>
        </div>
        <div>
          <OrderItemsList className="my-6 border-y" lineItems={order.lineItems || []} />
        </div>
      </>
    )
  );
};

export default OrderPage;
